export default "__VITE_PUBLIC_ASSET__08d79bc8__"